import {
  Grid,
  IconButton,
  Typography,
  Button,
  Dialog,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import { ConfirmationProps } from './types';
import useStyles from './styles';

const ConfirmationModal = (props: ConfirmationProps) => {
  const {
    open,
    header,
    content,
    onCancelText,
    onConfirmText,
    onConfirm,
    onCancel,
    hideCancel,
    type = 'save',
  } = props;
  const classes = useStyles();

  const getDefaultHeader = () => {
    if (type === 'delete') {
      return 'Delete';
    }
    if (type === 'save') {
      return 'Save changes?';
    }
    if (type === 'leave') {
      return 'Are you sure you want to leave?';
    }

    return '';
  };

  const getDefaultConfirmText = () => {
    if (type === 'delete') {
      return 'Delete';
    }
    if (type === 'save') {
      return 'Save';
    }
    if (type === 'leave') {
      return 'Leave';
    }

    return '';
  };

  const getDefaultCancelText = () => {
    if (type === 'leave') {
      return 'Stay';
    }

    return 'Cancel';
  };

  const getDefaultContent = () => {
    if (type === 'delete') {
      return (
        <>
          <Typography>Are you sure you want to do this?</Typography>
          <Typography variant="caption">Note: You cannot undo this</Typography>
        </>
      );
    }
    if (type === 'save') {
      return (
        <Typography color="textSecondary">
          All edits that were made will only be applied to a new cases that will
          be associated with this workflow. Cases ongoing cases won’t be
          affected.
        </Typography>
      );
    }
    if (type === 'leave') {
      return (
        <Typography color="textSecondary">
          You have unsaved changes. If you leave the page, these changes will be
          lost.
        </Typography>
      );
    }

    return '';
  };

  return (
    <Dialog open={open} onClose={onCancel}>
      <div className={classes.root}>
        <Grid
          container
          className={classes.heading}
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h4">{header || getDefaultHeader()}</Typography>
          <IconButton size="small" onClick={onCancel}>
            <CloseIcon />
          </IconButton>
        </Grid>
        {content || getDefaultContent()}
        <div className={classes.controls}>
          {
            !hideCancel && (
              <Button variant="outlined" onClick={onCancel}>
                {onCancelText || getDefaultCancelText()}
              </Button>
            )
          }
          <Button
            variant="contained"
            color="secondary"
            className={clsx(
              ['delete', 'leave'].includes(type) && classes.errorButton,
            )}
            onClick={onConfirm}
          >
            {onConfirmText || getDefaultConfirmText()}
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
